/*
 * Copyright (C) 2018 Spanning Cloud Apps.  All rights reserved.
 */
/**
 * Service module for reporting errors.
 */
(function () {
  'use strict';

  angular.module('services.error', ['sbsf.constants']).factory('ErrorService', factory);

  factory.$inject = ['$rootScope', 'ALERT_EVENTS'];

  /**
   * Builds and returns the ErrorService object.
   *
   * @returns {object} - the ErrorService object
   */
  function factory($rootScope, ALERT_EVENTS) {
    return {
      report: report
    };

    /**
     * Reports an error to the user. In this implementation we emit an event that causes a toast to be displayed.
     *
     * @param {object} err - the error to be reported.
     * @param {string} [defaultMsg] - an optional message to be displayed if no message can be determined from the
     *   error.
     */
    function report(err, defaultMsg) {
      var msg;
      if (typeof err === 'string') {
        msg = err;
      } else if (err && err.message) {
        msg = err.message;
      } else if (err && err.data && err.data.message) {
        msg = err.data.message;
      } else if (defaultMsg) {
        msg = defaultMsg;
      } else {
        msg = 'Unknown error';
      }

      $rootScope.$emit(ALERT_EVENTS.ERROR.eventName, msg);
    }
  }
})();
